// extracted by mini-css-extract-plugin
export default {"homeTitle":"HomeContent_homeTitle__TwXyi","homeSection":"HomeContent_homeSection__B5ya5","homeImg":"HomeContent_homeImg__YsHEy"};